import React from 'react';

import LinkButton from '@/components/atoms/linkButton/index';
import { Text } from '@/components/atoms/text';

export type JobType = 'Full-time' | 'Part-time' | 'Contract';

export type OpenPositionsItemProps = {
  slug: string;
  metaTitle?: string;
  city?: string;
  jobType?: JobType;
};

export default function OpenPositionsItem({
  slug,
  metaTitle,
  city,
  jobType,
}: OpenPositionsItemProps) {
  return (
    <div className='border-neutral-N20 grid grid-cols-1 items-center justify-between border-t py-6 sm:flex'>
      <LinkButton
        variant='text'
        slim
        underline={false}
        color='secondary'
        href={`/${slug}`}
        textWrap
        data-tracker-component='text'
      >
        <div className='text-left'>
          <Text className='text-subtitle-l pb-3'>{metaTitle}</Text>
          <Text className='text-body-l text-neutral-N80'>
            {city} / {jobType}
          </Text>
        </div>
      </LinkButton>
      <LinkButton
        variant='outlined'
        underline={false}
        href={`/${slug}`}
        textWrap
        data-tracker-component='button-details'
        classNames={{ root: 'w-full mt-6 sm:mt-0 sm:w-[100px]' }}
      >
        <Text className='text-primary-P99'>Details</Text>
      </LinkButton>
    </div>
  );
}
